module.exports = __webpack_public_path__ + "media/images/emblems/Courroux-coat_of_arms-775afd8c146795fa9543bb1bfb503c9a.svg";